import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  IconButton,
} from "@material-ui/core";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import HelpOutline from "@material-ui/icons/HelpOutline";
import InfoOutline from "@material-ui/icons/InfoOutlined";
import ProjectAutoComplete from "./ProjectAutoComplete";
import {
  saProjectFetchList,
  saProjectQueryParams,
  saFlightPost,
  saCalQueryParams,
  saCalFetchList,
} from "./SACreateActions";
import Ajv from "ajv";
import pako from "pako";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import { NoEncryption } from "@material-ui/icons";
import Help from '@material-ui/icons/HelpOutline'
import NicerTooltip from '../common/NicerTooltip';

const SAFlightCreate = (props) => {

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [ws, setWs] = useState(null);

  // const { setQueryParams } = props;
  const selectRef = useRef(null);
  // const prjNoRef = useRef(null);

  const SENSOR_NUMBER = 418;
  const SENSOR_NAME = "Optech Galaxy Prime - 418";

  const [state, setState] = useState({});

  const updateState = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedCalibrationTab, setSelectedCalibrationTab] = useState(1);

  const [isProjectValid, setIsProjectValid] = useState(false);
  const [isFlightSectionDisabled, setIsFlightSectionDisabled] = useState(true);
  const [isCalSectionDisabled, setIsCalSectionDisabled] = useState(true);

  // Project values
  const [projectNo, setProjectNo] = useState("");
  const [projectNoError, setProjectNoError] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [projectNameError, setProjectNameError] = useState(false);
  const [processingTemplate, setProcessingTemplate] = useState("");
  // Flight values
  const [aircraft, setAircraft] = useState("");
  const [wheelsUp, setWheelsUp] = useState("");
  const [wheelsDown, setWheelsDown] = useState("");
  const [wheelsUpDownError, setWheelsUpDownError] = useState(false);

  const [calibrationDate, setCalibrationDate] = useState("");
  // Reference to Primary GNSS Lever Arm (m)
  const [PriGNSSLeverX, setPriGNSSLeverX] = useState("");
  const [PriGNSSLeverY, setPriGNSSLeverY] = useState("");
  const [PriGNSSLeverZ, setPriGNSSLeverZ] = useState("");
  // Reference to IMU Lever Arm (m)
  const [RefToIMULeverX, setRefToIMULeverX] = useState("");
  const [RefToIMULeverY, setRefToIMULeverY] = useState("");
  const [RefToIMULeverZ, setRefToIMULeverZ] = useState("");
  // Reference to IMU Mounting Angles (decimal degrees)
  const [RefToIMUMountingAnglX, setRefToIMUMountingAnglX] = useState("");
  const [RefToIMUMountingAnglY, setRefToIMUMountingAnglY] = useState("");
  const [RefToIMUMountingAnglZ, setRefToIMUMountingAnglZ] = useState("");

  // const [LMSInstrumentRES, setLMSInstrumentRES] = useState("");
  // const [LMSInstrumentTBL, setLMSInstrumentTBL] = useState("");
  // const [LMSInstrumentLCP, setLMSInstrumentLCP] = useState("");
  const [calSelectEnabled, setCalSelectEnabled] = useState(false);
  const [calFilesValid, setCalFilesValid] = useState(true);

  const [submitValid, setSubmitValid] = useState(false);

  // const [existingProjectName, setExistingProjectName] = useState("");
  // const [existingProcessingTemplate, setExistingProcessingTemplate] = useState(
  //   ""
  // );
  const [isExistingProject, setIsExistingProject] = useState(false);
  const [isNewProject, setIsNewProject] = useState(false);
  const [existingProjectObjId, setExistingProjectObjId] = useState("");

  const [existingCalibrationDate, setExistingCalibrationDate] = useState("");
  const [existingCalTabDisabled, setExistingCalTabDisabled] = useState(false);
  const [existingCalibrationId, setExistingCalibrationId] = useState("");

  // Reference to Primary GNSS Lever Arm (m)
  // const [PriGNSSLeverX, setPriGNSSLeverX] = useState("");
  // const [PriGNSSLeverY, setPriGNSSLeverY] = useState("");
  // const [PriGNSSLeverZ, setPriGNSSLeverZ] = useState("");
  // // Reference to IMU Lever Arm (m)
  // const [RefToIMULeverX, setRefToIMULeverX] = useState("");
  // const [RefToIMULeverY, setRefToIMULeverY] = useState("");
  // const [RefToIMULeverZ, setRefToIMULeverZ] = useState("");
  // // Reference to IMU Mounting Angles (decimal degrees)
  // const [RefToIMUMountingAnglX, setRefToIMUMountingAnglX] = useState("");
  // const [RefToIMUMountingAnglY, setRefToIMUMountingAnglY] = useState("");
  // const [RefToIMUMountingAnglZ, setRefToIMUMountingAnglZ] = useState("");

  useEffect(() => {
    if (projectNo.length == 8 && projectName.length > 0 && processingTemplate.length > 0) {
      setIsFlightSectionDisabled(false);
    }
    else {
      setIsFlightSectionDisabled(true);
    }
  }, [projectNo, projectName, processingTemplate]);

  useEffect(() => {
    if (aircraft && wheelsUp !== "" && wheelsDown !== "" && Date.parse(wheelsUp) < Date.parse(wheelsDown)) {
      setIsCalSectionDisabled(false);
    }

  }, [aircraft, wheelsUp, wheelsDown]);

  useEffect(() => {
    // Check combined validity of states
    // const valid = field1.trim() !== '' && field2.trim() !== '' && /* other conditions */;
    const valid =
      (projectNo.length == 8 &&
        projectName.length > 0 &&
        processingTemplate &&
        aircraft &&
        Date.parse(wheelsUp) < Date.parse(wheelsDown) &&
        (calibrationDate || existingCalibrationDate) &&
        PriGNSSLeverX) ||
      (PriGNSSLeverX.length > 0 && PriGNSSLeverY) ||
      (PriGNSSLeverY.length > 0 && PriGNSSLeverZ) ||
      (PriGNSSLeverZ.length > 0 && RefToIMULeverX) ||
      (RefToIMULeverX.length > 0 && RefToIMULeverY) ||
      (RefToIMULeverY.length > 0 && RefToIMULeverZ) ||
      (RefToIMULeverZ.length > 0 && RefToIMUMountingAnglX) ||
      (RefToIMUMountingAnglX.length > 0 && RefToIMUMountingAnglY) ||
      (RefToIMUMountingAnglY.length > 0 && RefToIMUMountingAnglZ) ||
      (RefToIMUMountingAnglZ.length > 0 &&

        ((state.LMSInstrumentRES &&
          state.LMSInstrumentLCP &&
          state.LMSInstrumentTBL) || existingCalibrationId !== ""));

    console.log("...existingCalibrationId", existingCalibrationId !== "")
    console.log("...(state.LMSInstrumentRES && state.LMSInstrumentLCP && state.LMSInstrumentTBL) ", (state.LMSInstrumentRES && state.LMSInstrumentLCP && state.LMSInstrumentTBL))
    console.log("...combined", ((state.LMSInstrumentRES && state.LMSInstrumentLCP && state.LMSInstrumentTBL) || existingCalibrationId !== ""))
    console.log("...calibrationDate ", calibrationDate)

    // console.log("...valid", RefToIMUMountingAnglZ);
    console.log("...valid1 ", valid)
    setSubmitValid(valid);
  }, [
    projectNo,
    projectName,
    processingTemplate,
    aircraft,
    wheelsUp,
    wheelsDown,
    calibrationDate,
    PriGNSSLeverX,
    PriGNSSLeverY,
    PriGNSSLeverZ,
    RefToIMULeverX,
    RefToIMULeverY,
    RefToIMULeverZ,
    RefToIMUMountingAnglX,
    RefToIMUMountingAnglY,
    RefToIMUMountingAnglZ,
    state.LMSInstrumentRES,
    state.LMSInstrumentLCP,
    state.LMSInstrumentTBL,
  ]); //

  useEffect(() => {
    if (props.submitSuccess) {
      // console.log("...redirect, props", props);
      props.history.push(props.submitSuccess.resource[0]);
      // props.history.push('/post/FL100000');
    }
  }, [props.submitSuccess]);

  useEffect(() => {
    if (props.saCal) {
      if (props.saCal && props.saCal.CalibrationParameter.length > 0) {
        const calParam = props.saCal.CalibrationParameter[0];
        setSelectedCalibrationTab(0);
        setExistingCalibrationDate(calParam.SurveyDate);
        setAircraft(calParam.Aircraft);
        // setCalibrationDate(calParam.SurveyDate);
        setPriGNSSLeverX(calParam.PriGNSSLeverX);
        setPriGNSSLeverY(calParam.PriGNSSLeverY);
        setPriGNSSLeverZ(calParam.PriGNSSLeverZ);
        // Reference to IMU Lever Arm (m)
        setRefToIMULeverX(calParam.RefToIMULeverX);
        setRefToIMULeverY(calParam.RefToIMULeverY);
        setRefToIMULeverZ(calParam.RefToIMULeverZ);
        // Reference to IMU Mounting Angles (decimal degrees)
        setRefToIMUMountingAnglX(calParam.RefToIMUMountingAnglX);
        setRefToIMUMountingAnglY(calParam.RefToIMUMountingAnglY);
        setRefToIMUMountingAnglZ(calParam.RefToIMUMountingAnglZ);
        setExistingCalibrationId(calParam._id);

        console.log("...valid2")
        setSubmitValid(true);//this actually triggers the re-assessment of validity
      } else {
        setSelectedCalibrationTab(1);
        setExistingCalibrationId("");
        //also toggle the 'missing' message
        //disable the existing tab
      }
    }
  }, [props.saCal]);

  // const handleChange = (event, value) => {
  //   setSelectedTab(value);
  //   // setQueryParams({ page:1, pageSize:10, partialProjectID:"PRJ48687"});
  // };

  const handleOpenHelp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open('../../SAFlightCreationHelp.pdf')
  }

  const handleCalibratonTabChange = (event, value) => {
    setSelectedCalibrationTab(value);
  };

  // const validateProjectNo = (event) => {
  //   const input = event.target.value;
  //   const acceptedInput = /^[0-9]{0,8}$/;
  //   // const finalRegex = /^1002\d{4}$/;
  //   // Test if the input matches the regex
  //   if (acceptedInput.test(input) || input === "") {
  //     setProjectNo(input);
  //     setProjectNoError(false);
  //   } else {
  //     setProjectNoError(true);
  //   }
  // };

  const validateProjectName = (event) => {
    const input = event.target.value;
    const acceptedInput = /^[a-zA-Z0-9 ]*$/;
    // Test if the input matches the regex
    if (acceptedInput.test(input) || input === "") {
      setProjectName(input);
      setProjectNameError(false);
    } else {
      setProjectNameError(true);
    }
  };

  const handleProjectSelection = (value) => {
    // console.log("...handleProjectSelection: ", value);
    // setExistingProjectName(value.ProjectName);
    // setExistingProcessingTemplate(value.ProcessingTemplate);
    setProjectNo(value.ProjectID);
    setProjectName(value.ProjectName);
    setProcessingTemplate(value.ProcessingTemplate);
    // if(value._id)
    setExistingProjectObjId(value._id)
    setIsExistingProject(true);
  };

  const incompleteProjectCallback = (value) => {
    if (isExistingProject) {
      setIsExistingProject(false);
      setProjectName("");
      setProcessingTemplate("");
      setExistingProjectObjId("");
    }
    if (isNewProject) {
      setIsNewProject(false);
      setProjectNo(value);
    }
    // if (numSuggestions == 0) {
    //   setIsNewProject(true);
    // }
  };

  const completedProjectCallback = (value) => {

    // if(isExistingProject){
    // setIsExistingProject(false);
    setIsNewProject(true);
    setProjectNo(value);
    //   setProcessingTemplate("");
    // }
  };

  useEffect(() => {
    if (wheelsUp !== "" && wheelsDown !== "") {
      const isValidPair = Date.parse(wheelsUp) < Date.parse(wheelsDown);
      setWheelsUpDownError(!isValidPair);
    } else {
      setWheelsUpDownError(false);
    }
  }, [wheelsUp, wheelsDown]);

  useEffect(() => {
    const valid = SENSOR_NUMBER && aircraft && calibrationDate ? true : false;
    setCalSelectEnabled(valid);
  }, [SENSOR_NUMBER, aircraft, calibrationDate]);

  useEffect(() => {
    if (aircraft && wheelsUp) {
      // props.setCalQueryParams({
      //   aircraft: aircraft,
      //   surveyDate: wheelsUp,
      // });
      props.getCalQueryParams({
        aircraft: aircraft,
        surveyDate: wheelsUp,
      });
    }
  }, [aircraft, wheelsUp]);

  const readFileAsJSON = (inputFile, fieldName, compress = false) => {
    let r = new FileReader();
    r.onload = (e) => {
      let contents = e.target.result;

      let compressed = null;
      if (compress) {
        compressed = pako.deflate(JSON.stringify(contents), { to: "string" });
        // var result = JSON.parse(pako.inflate(test, { to: 'string' }));//just for testing
      }

      updateState("FileName" + fieldName, inputFile.name);
      updateState(fieldName, compress ? btoa(compressed) : contents);
    };
    r.readAsText(inputFile);
  };

  //a hack, because inputs dont work when reselecting the same folder
  const inputReset = () => {
    // ReactDOM.findDOMNode(this.refs.selectButton).value = "";
    selectRef.current.value = "";
  };

  //validating filenames: 5060999_VH-LAV_LMS50_06052025 *.lcp. *.res *.tbl
  const onUpload = (event) => {
    // console.log("...sensorNumber", SENSOR_NUMBER);
    // console.log("...calibrationDate", calibrationDate.split("T")[0]);
    // console.log("...aircraft", aircraft);

    event.persist();

    let sensorNumber = SENSOR_NUMBER; //this.state.SensorName.slice(-3);
    let date = calibrationDate.split("T")[0]; //in case in edit mode... db has time in there too
    date = date.split("-");
    date = date[2] + date[1] + date[0];
    let base_pattern =
      "^(\\d{4}" +
      sensorNumber +
      "|\\d{2}SEN" +
      sensorNumber +
      ")_" +
      aircraft +
      "_LMS\\d{2}_" +
      date;
    let res_pattern = base_pattern + ".(RES|res)$";
    let tbl_pattern = base_pattern + ".(TBL|tbl)$";
    let lcp_pattern = base_pattern + ".(LCP|lcp)$";

    let schema = {
      type: "object",
      properties: {
        RES: {
          type: "array",
          minItems: 1,
          maxItems: 1,
          errorMessage: "Exactly 1 RES file is required.",
          items: {
            type: "string",
            pattern: res_pattern,
            errorMessage:
              "RES file doesn't match naming standard. Please check the sensor number is: " +
              sensorNumber +
              ", aircraft serial is: " +
              aircraft +
              " and date is: " +
              date +
              ". Current file name:",
          },
        },
        TBL: {
          type: "array",
          minItems: 1,
          maxItems: 1,
          errorMessage: "Exactly 1 TBL file is required.",
          items: {
            type: "string",
            pattern: tbl_pattern,
            errorMessage:
              "TBL file doesn't match naming standard. Please check the sensor number is: " +
              sensorNumber +
              ", aircraft serial is: " +
              aircraft +
              " and date is: " +
              date +
              ". Current file name:",
          },
        },
        LCP: {
          type: "array",
          minItems: 1,
          maxItems: 1,
          errorMessage: "Exactly 1 LCP file is required.",
          items: {
            type: "string",
            pattern: lcp_pattern,
            errorMessage:
              "LCP file doesn't match naming standard. Please check the sensor number is: " +
              sensorNumber +
              ", aircraft serial is: " +
              aircraft +
              " and date is: " +
              date +
              ". Current file name:",
          },
        },
      },
      required: ["RES", "TBL", "LCP"],
    };

    let summary = {
      RES: [],
      TBL: [],
      LCP: [],
    };

    let resFile = null;
    let tblFile = null;
    let lcpFile = null;

    for (let i = 0; i < event.target.files.length; i++) {
      let extn = event.target.files[i].name.slice(-3).toLowerCase();
      switch (extn) {
        case "res":
          summary["RES"].push(event.target.files[i].name);
          resFile = event.target.files[i];
          break;
        case "tbl":
          summary["TBL"].push(event.target.files[i].name);
          tblFile = event.target.files[i];
          break;
        case "lcp":
          summary["LCP"].push(event.target.files[i].name);
          lcpFile = event.target.files[i];
          break;
        default:
      }
    }

    let errors = [];
    let ajv = new Ajv({ allErrors: true, verbose: true });
    let valid = ajv.validate(schema, summary);

    if (!valid) {
      /// previous uploads aren;t evaluated as a whole
      console.log("Calibration file validation failed");
      ajv.errors.forEach(function (error) {
        let errorMessage = "";
        if (error.keyword == "required") {
          errorMessage =
            error.schema[error.params.missingProperty].errorMessage;
        } else if (error.data instanceof Array) {
          error.data = error.data.join(", "); //convert to a string that can be wrapped
          errorMessage = error.parentSchema.errorMessage + " " + error.data;
        } else {
          errorMessage = error.parentSchema.errorMessage + " " + error.data;
        }
        errors.push(errorMessage);
      });

      console.log("errors:", errors);

      updateState("LMSInstrumentRES", "");
      updateState("LMSInstrumentTBL", "");
      updateState("LMSInstrumentLCP", "");
      setCalFilesValid(false);
    } else {
      console.log("Calibration files valid", valid);

      readFileAsJSON(resFile, "LMSInstrumentRES");
      readFileAsJSON(tblFile, "LMSInstrumentTBL", true);
      readFileAsJSON(lcpFile, "LMSInstrumentLCP");

      // this.state.LMSVersion = this.props.currentLMSVersion;
      setCalFilesValid(true);
    }

    // this.setState({ validationDialogVisible: !valid, errors: errors });
  };

  const handleSubmit = () => {

    // if (selectedCalibrationTab == 1){
    //     setExistingCalibrationId("");
    // }
    // let _id = "";
    // if(existingProjectObjId)
    //   id = existingProjectObjId
    const payload = {
      Flight: {
        Aircraft: aircraft, //"ZS-NDN",
        WheelsUp: wheelsUp + ":00.000+00:00", //"2025-06-02T01:05:25.000Z",
        WheelsDown: wheelsDown + ":00.000+00:00", //"2025-06-02T04:05:25.000Z",
        LiDARSensor: SENSOR_NAME,
      },
      Project: {
        _id: existingProjectObjId,
        ProjectID: projectNo,
        ProjectName: projectName,
        ProcessingTemplate: processingTemplate,
      },
      CalParam: {
        // _id: existingCalibrationId,
        _id: selectedCalibrationTab == 1 ? "" : existingCalibrationId,//when there is a preexisting selection, but its manually overridden
        // SensorName:"Optech Galaxy Prime - 473",#hardcoded
        Aircraft: aircraft,
        PriGNSSLeverX: PriGNSSLeverX,
        PriGNSSLeverY: PriGNSSLeverY,
        PriGNSSLeverZ: PriGNSSLeverZ,
        RefToIMULeverX: RefToIMULeverX,
        RefToIMULeverY: RefToIMULeverY,
        RefToIMULeverZ: RefToIMULeverZ,
        RefToIMUMountingAnglX: RefToIMUMountingAnglX,
        RefToIMUMountingAnglY: RefToIMUMountingAnglY,
        RefToIMUMountingAnglZ: RefToIMUMountingAnglZ,
        LMSInstrumentRES: state.LMSInstrumentRES,
        LMSInstrumentTBL: state.LMSInstrumentTBL,
        LMSInstrumentLCP: state.LMSInstrumentLCP,
        SurveyDate: calibrationDate + "T00:00:00.000+00:00",
        // AircraftType:"FixedWing",
        // PriGNSSLeverSD:"SD10cm",
        // IsActive:true,
        LMSVersion: "4.6.1.30889",
        FileNameLMSInstrumentRES: state.FileNameLMSInstrumentRES,
        FileNameLMSInstrumentLCP: state.FileNameLMSInstrumentLCP, //"5060473_VH-NLG_LMS46_04032024.LCP",
        FileNameLMSInstrumentTBL: state.FileNameLMSInstrumentTBL, //"5060473_VH-NLG_LMS46_04032024.TBL",
        CompositeID: aircraft + " " + SENSOR_NAME + " " + calibrationDate, //"VH-NLG Optech Galaxy Prime - 473 2024-03-04",
        SensorName: SENSOR_NAME,
        // Updated:"2024-05-13T01:56:14.947+00:00"
      },
    };

    props.submitFlight(payload);
    // props.history.push('/post');
  };

  const getCalDate = (calDate) => {
    let date = calDate.split("T")[0]; //in case in edit mode... db has time in there too
    date = date.split("-");
    date = date[2] + date[1] + date[0];
    return date;
  };

  return (
    <div>
      <Grid container direction='row' alignItems='center' justify='flex-end'>
        <NicerTooltip placement="left" content="Help">
          <IconButton
            color="primary"
            style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 }}
            onClick={e => handleOpenHelp(e)}
          >
            <Help />
          </IconButton>
        </NicerTooltip>
      </Grid>
      <Grid container direction="column" alignItems="center" justify="center">
        <span style={{ fontWeight: "bold", fontSize: 18, marginBottom: 10 }}>
          South African Flight Entry
          <br />
          Optech Galaxy Prime - 418
        </span>

        {/* Start of Project section */}
        <div
          style={{
            outline: "#f0efed",
            outlineStyle: "solid",
            outlineWidth: 1,
            padding: 5,
            marginBottom: 5,
          }}
        >
          <span style={{ fontWeight: "bold", paddingTop: 10 }}>
            Project Details:
          </span>

          {/* <Tabs
            value={selectedTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="Select an Existing Project" />
            <Tab label="Create a New Project" />
          </Tabs> */}

          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
            style={{ width: "700px" }}
          >
            {/* Existing Project Tab*/}
            {/* {selectedTab == 0 && (
              <Grid
                container
                direction="row"
                alignItems="center"
                justify="space-between"
                style={{ paddingTop: 10, paddingBottom: 15 }}
              >
                               <div style={{ width: "200px" }}>
                  <ProjectAutoComplete
                    selectionCallback={handleProjectSelection}
                  />
                </div>

                <TextField
                  label="Project Name"
                  value={existingProjectName}
                  margin="dense"
                  InputProps={{
                    readOnly: true,
                  }}
                />

                <TextField
                  label="Processing Template"
                  value={existingProcessingTemplate}
                  margin="dense"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            )} */}

            {/* New Project Tab */}
            {/* {selectedTab == 1 && ( */}
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="space-between"
              style={{ paddingTop: 10, paddingBottom: 15 }}
            >
              {/* <TextField
                  label="Project Number"
                  margin="dense"
                  value={projectNo}
                  error={projectNoError}
                  helperText="An <8 digit> project number"
                  onChange={validateProjectNo}
                /> */}

              <div style={{ width: "200px", paddingTop: 5 }}>
                <ProjectAutoComplete
                  // ref={prjNoRef}
                  selectionCallback={handleProjectSelection}
                  incompleteCallback={incompleteProjectCallback}
                  completedCallback={completedProjectCallback}
                />
              </div>

              <TextField
                label="Project Name"
                margin="dense"
                value={projectName}
                error={projectNameError}
                helperText="A descriptve string, no special characters"
                onChange={validateProjectName}
              // InputProps={{
              //     endAdornment: <InputAdornment position="end">m</InputAdornment>,
              //     readOnly: !this.isEditable
              // }}
              //   style={{ paddingRight: 5, width: 195 }}
              />

              <FormControl>
                <InputLabel>Processing Template</InputLabel>
                <Select
                  value={processingTemplate}
                  onChange={(event) =>
                    setProcessingTemplate(event.target.value)
                  }
                  displayEmpty
                  style={{ width: "200px", marginBottom: 16 }}
                // inputProps={{
                //   name: "age",
                //   id: "age-simple",
                // }}
                >
                  {/* <MenuItem value="RTXHART-LMSRefCal-MiningAI">Hart</MenuItem> */}
                  {/* <MenuItem value="RTXITRF20-LMSStd-MiningAI8PPM">UTM : MiningAI (LAS 1.2)</MenuItem>
                  <MenuItem value="RTXITRF20-LMSStd-RuralAI">UTM : RuralAI (LAS 1.4)</MenuItem>
                  <MenuItem value="RTXITRF20-LMSStd-UrbanAI">UTM : UrbanAI (LAS 1.4)</MenuItem> */}
                  {/* <MenuItem value="RTXITRF20-LMSRefCal-MiningAI8PPM2025">MiningAI: UTM, LMSRefCal, LAS 1.2</MenuItem> */}
                  <MenuItem value="RTXITRF20-LMSRefCal-MiningAI8PPMLegacy2025">MiningAI: UTM, LMSRefCal, LAS 1.2</MenuItem>
                  <MenuItem value="RTXITRF20-LMSRefCal-RuralAI">RuralAI: UTM, LMS RefCal, LAS 1.4</MenuItem>
                  <MenuItem value="RTXITRF20-LMSRefCal-UrbanAI">UrbanAI: UTM, LMS RefCal, LAS 1.4</MenuItem>
                  <MenuItem value="RTXITRF20-LMSStd-RuralAINoSA">Corridor RuralAI: UTM, LMS Std, LAS 1.4, No Strip Align</MenuItem>
                  <MenuItem value="RTXITRF20-LMSStd-UrbanAINoSA">Corridor UrbanAI: UTM, LMS Std, LAS 1.4, No Strip Align</MenuItem>
                  <MenuItem value="RTXITRF20">GPS Only</MenuItem>
                  <MenuItem value="RTXITRF20-LMSStd">GPS & LMS Std Only</MenuItem>
                  <MenuItem value="RTXITRF20-LMSRefCal">GPS & LMS RefCal Only</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* )} */}

            {isExistingProject && (
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                justify="flex-start"
              >
                <InfoOutline style={{ fontSize: 36, color: "#1a3a69" }} />
                <p style={{ marginTop: -36, marginLeft: 40 }}>
                  Entered Project Number matches an existing Project. This
                  existing Project has been selected and will be associated to
                  this Flight and Processing.
                </p>
              </Grid>
            )}

            {isNewProject && (
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                justify="flex-start"
              >
                <InfoOutline style={{ fontSize: 36, color: "#1a3a69" }} />
                <p style={{ marginTop: -36, marginLeft: 40 }}>
                  Entered Project Number does not match any existing Projects. A
                  new Project will be created and associated to this Flight and
                  Processing.
                </p>
              </Grid>
            )}
          </Grid>
        </div>

        {/* Start of Flight section */}
        <div
          style={{
            outline: "#f0efed",
            outlineStyle: "solid",
            outlineWidth: 1,
            padding: 5,
            marginBottom: 5,
            opacity: isFlightSectionDisabled ? 0.3 : 1,
            pointerEvents: isFlightSectionDisabled ? "none" : "auto"
          }}
        >
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <span style={{ fontWeight: "bold" }}>Flight Details:</span>
            <span style={{ fontSize: 12, color: "#757575" }}>
              Please ensure all dates & times are entered in UTC
            </span>
          </Grid>

          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
            style={{ width: "700px", paddingTop: 10, paddingBottom: 15 }}
          >
            <FormControl>
              <InputLabel>Aircraft</InputLabel>
              <Select
                value={aircraft}
                onChange={(event) => setAircraft(event.target.value)}
                style={{ width: "200px" }}
              >
                {/* TODO: get from SA_AIRCRAFT collection */}
                <MenuItem value="ZS-NDN">ZS-NDN</MenuItem>
                <MenuItem value="ZS-OWL">ZS-OWL</MenuItem>
                <MenuItem value="ZS-SSY">ZS-SSY</MenuItem>
                <MenuItem value="ZS-BRD">ZS-BRD</MenuItem>
                <MenuItem value="ZS-XTR">ZS-XTR</MenuItem>
              </Select>
            </FormControl>

            <TextField
              //   id="datetime-local"
              label="Wheels Up (UTC)"
              type="datetime-local"
              value={wheelsUp}
              onChange={(event) => setWheelsUp(event.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />

            {/* <TextField
              id="time"
              label="Alarm clock"
              type="time"
              // defaultValue="07:30"
              // className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5 min
                lang: "en-GB", // Suggests 24-hour format (e.g., 14:30 instead of 2:30 PM)
              }}
              ampm={false}
            /> */}

            <TextField
              label="Wheels Down (UTC)"
              type="datetime-local"
              value={wheelsDown}
              onChange={(event) => setWheelsDown(event.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                lang: "en-GB", // Suggests 24-hour format (e.g., 14:30 instead of 2:30 PM)
              }}
              ampm={false}
            />
          </Grid>
          {true && (
            <p
              style={{
                visibility: wheelsUpDownError ? "visible" : "hidden",
                fontSize: 12,
                color: "#FF0000",
                marginTop: 0,
                textAlign: "center",
              }}
            >
              'Wheels Up' must be before 'Wheels Down'!
            </p>
          )}
        </div>

        {/* Start of Calibration section */}
        <div
          style={{
            outline: "#f0efed",
            outlineStyle: "solid",
            outlineWidth: 1,
            padding: 5,
            opacity: isCalSectionDisabled ? 0.3 : 1,
            pointerEvents: isCalSectionDisabled ? "none" : "auto"
          }}
        >
          <span style={{ fontWeight: "bold" }}>Calibration Parameters:</span>

          <Tabs
            value={selectedCalibrationTab}
            onChange={handleCalibratonTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              label="Select an Existing Calibration"
              disabled={existingCalTabDisabled}
            />
            <Tab label="Create a New Calibration" />
          </Tabs>

          {selectedCalibrationTab == 0 && (
            <Grid
              container
              direction="column"
              alignItems="center"
              justify="center"
              style={{ paddingTop: "5px", paddingBottom: "5px" }}
            >
              <Grid
                container
                direction="row"
                alignItems="center"
                justify="space-evently"
                // justify="center"
                style={{ width: "700px", paddingTop: 10, paddingBottom: 15 }}
              >
                <HelpOutline
                  style={{ fontSize: 40, color: "#1a3a69", paddingLeft: 5 }}
                />
                <div style={{ marginLeft: 50, marginTop: -47 }}>
                  This Calibration was auto-selected based off Flight Date
                  (Wheels Up) and Aircraft selection. Please ensure that this
                  matches the expected Calibration; if not create a{" "}
                  <strong>NEW CALIBRATION</strong> entry.
                </div>

                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                  style={{ paddingTop: 10, paddingBottom: 15 }}
                >
                  <span>
                    {/* <span style={{ fontWeight: "bold" }}>SENSOR:</span>{" "} */}
                    {/* {this.state.SensorName} */}
                    &nbsp;
                    <span style={{ fontWeight: "bold" }}>AIRCRAFT:</span>{" "}
                    {aircraft}, &nbsp;
                    <span style={{ fontWeight: "bold" }}>
                      SURVEY DATE (UTC):
                    </span>{" "}
                    {existingCalibrationDate}
                    {/* {calibrationDate} */}
                  </span>
                </Grid>
              </Grid>
              <Grid
                container
                direction="column"
                alignItems="flex-start"
                style={{ width: 600, paddingTop: 10 }}
              >
                <span style={{ fontWeight: "bold", fontSize: 14 }}>
                  Reference to Primary GNSS Lever Arm (m):
                </span>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <TextField
                    id="standard-name"
                    label="X"
                    margin="dense"
                    type="number"
                    value={PriGNSSLeverX}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    style={{ paddingRight: 5, width: 195 }}
                  />

                  <TextField
                    id="standard-name"
                    label="Y"
                    margin="dense"
                    type="number"
                    value={PriGNSSLeverY}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    style={{ paddingRight: 5, width: 195 }}
                  />

                  <TextField
                    id="standard-name"
                    label="Z"
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    style={{ width: 195 }}
                    value={PriGNSSLeverZ}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="column"
                alignItems="center"
                style={{ width: 600, paddingTop: 10 }}
              >
                <span style={{ fontWeight: "bold", fontSize: 14 }}>
                  Reference to IMU Lever Arm (m):
                </span>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <TextField
                    id="standard-name"
                    label="X"
                    value={RefToIMULeverX}
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    style={{ paddingRight: 5, width: 195 }}
                  />

                  <TextField
                    id="standard-name"
                    label="Y"
                    value={RefToIMULeverY}
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    style={{ paddingRight: 5, width: 195 }}
                  />

                  <TextField
                    id="standard-name"
                    label="Z"
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    style={{ width: 195 }}
                    value={RefToIMULeverZ}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="column"
                alignItems="flex-start"
                style={{ width: 600, paddingTop: 10 }}
              >
                <span style={{ fontWeight: "bold", fontSize: 14 }}>
                  Reference to IMU Mounting Angles (decimal degrees):
                </span>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <TextField
                    id="standard-name"
                    label="X"
                    margin="dense"
                    type="number"
                    value={RefToIMUMountingAnglX}
                    style={{ paddingRight: 5, width: 195 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">&deg;</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                  />

                  <TextField
                    id="standard-name"
                    label="Y"
                    margin="dense"
                    type="number"
                    value={RefToIMUMountingAnglY}
                    style={{ paddingRight: 5, width: 195 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">&deg;</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                  />

                  <TextField
                    id="standard-name"
                    label="Z"
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">&deg;</InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    style={{ width: 195 }}
                    value={RefToIMUMountingAnglZ}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          {selectedCalibrationTab == 1 && (
            <Grid
              container
              direction="column"
              alignItems="center"
              justify="center"
              style={{ paddingTop: "5px", paddingBottom: "5px" }}
            >
              <Grid
                container
                direction="row"
                alignItems="center"
                justify="space-evently"
                // justify="center"
                style={{ width: "700px", paddingTop: 10, paddingBottom: 15 }}
              >
                <ErrorOutline
                  style={{ fontSize: 40, color: "#FF0000", paddingLeft: 5 }}
                />
                <div style={{ marginLeft: 50, marginTop: -37 }}>
                  No valid Calibration was found; based off Aircraft and Flight
                  date (Wheels Up). Please create a new Calibration for this
                  Aircraft, appropriate for this Flight date.
                </div>
              </Grid>

              <Grid
                container
                direction="row"
                alignItems="center"
                justify="space-evenly"
                style={{ width: "700px", paddingTop: 10, paddingBottom: 15 }}
              >
                <TextField
                  //   id="datetime-local"
                  label="Calibration Flight Date (UTC)"
                  type="date"
                  value={calibrationDate}
                  onChange={(event) => setCalibrationDate(event.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: 210 }}
                />
              </Grid>

              <Grid
                container
                direction="column"
                alignItems="flex-start"
                style={{ width: 600, paddingTop: 10 }}
              >
                <span style={{ fontWeight: "bold", fontSize: 14 }}>
                  Reference to Primary GNSS Lever Arm (m):
                </span>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <TextField
                    label="X"
                    margin="dense"
                    type="number"
                    value={PriGNSSLeverX}
                    onChange={(event) =>
                      setPriGNSSLeverX(parseFloat(event.target.value))
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      // readOnly: !this.isEditable
                    }}
                    style={{ paddingRight: 5, width: 195 }}
                  />

                  <TextField
                    label="Y"
                    margin="dense"
                    type="number"
                    value={PriGNSSLeverY}
                    onChange={(event) =>
                      setPriGNSSLeverY(parseFloat(event.target.value))
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      // readOnly: !this.isEditable
                    }}
                    style={{ paddingRight: 5, width: 195 }}
                  />

                  <TextField
                    label="Z"
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      // readOnly: !this.isEditable
                    }}
                    style={{ width: 195 }}
                    value={PriGNSSLeverZ}
                    onChange={(event) =>
                      setPriGNSSLeverZ(parseFloat(event.target.value))
                    }
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="column"
                alignItems="flex-start"
                style={{ width: 600, paddingTop: 10 }}
              >
                <span style={{ fontWeight: "bold", fontSize: 14 }}>
                  Reference to IMU Lever Arm (m):
                </span>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <TextField
                    id="standard-name"
                    label="X"
                    value={RefToIMULeverX}
                    onChange={(event) =>
                      setRefToIMULeverX(parseFloat(event.target.value))
                    }
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      // readOnly: !this.isEditable,
                    }}
                    style={{ paddingRight: 5, width: 195 }}
                  />

                  <TextField
                    id="standard-name"
                    label="Y"
                    value={RefToIMULeverY}
                    onChange={(event) =>
                      setRefToIMULeverY(parseFloat(event.target.value))
                    }
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      // readOnly: !this.isEditable,
                    }}
                    style={{ paddingRight: 5, width: 195 }}
                  />

                  <TextField
                    id="standard-name"
                    label="Z"
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">m</InputAdornment>
                      ),
                      // readOnly: !this.isEditable,
                    }}
                    style={{ width: 195 }}
                    value={RefToIMULeverZ}
                    onChange={(event) =>
                      setRefToIMULeverZ(parseFloat(event.target.value))
                    }
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="column"
                alignItems="flex-start"
                style={{ width: 600, paddingTop: 10 }}
              >
                <span style={{ fontWeight: "bold", fontSize: 14 }}>
                  Reference to IMU Mounting Angles (decimal degrees):
                </span>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <TextField
                    id="standard-name"
                    label="X"
                    margin="dense"
                    type="number"
                    value={RefToIMUMountingAnglX}
                    onChange={(event) =>
                      setRefToIMUMountingAnglX(parseFloat(event.target.value))
                    }
                    style={{ paddingRight: 5, width: 195 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">&deg;</InputAdornment>
                      ),
                      // readOnly: !this.isEditable,
                    }}
                  />

                  <TextField
                    id="standard-name"
                    label="Y"
                    margin="dense"
                    type="number"
                    value={RefToIMUMountingAnglY}
                    onChange={(event) =>
                      setRefToIMUMountingAnglY(parseFloat(event.target.value))
                    }
                    style={{ paddingRight: 5, width: 195 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">&deg;</InputAdornment>
                      ),
                      // readOnly: !this.isEditable,
                    }}
                  />

                  <TextField
                    id="standard-name"
                    label="Z"
                    margin="dense"
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">&deg;</InputAdornment>
                      ),
                      // readOnly: !this.isEditable,
                    }}
                    style={{ width: 195 }}
                    value={RefToIMUMountingAnglZ}
                    onChange={(event) =>
                      setRefToIMUMountingAnglZ(parseFloat(event.target.value))
                    }
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                alignItems="center"
                justify="center"
              >
                <input
                  // disabled={
                  // }
                  accept="*"
                  id="uploadButton"
                  webkitdirectory="true"
                  directory="true"
                  multiple
                  type="file"
                  style={{ display: "none" }}
                  onChange={(event) => onUpload(event)}
                  ref={selectRef}
                />

                <label htmlFor="uploadButton">
                  <Button
                    variant="contained"
                    component="span"
                    color="primary"
                    disabled={!calSelectEnabled}
                    onClick={inputReset}
                    style={{ width: 265, height: 30, marginRight: 10 }}
                  >
                    Select LMS Calibration Files
                  </Button>
                </label>

                {state.LMSInstrumentRES &&
                  state.LMSInstrumentLCP &&
                  state.LMSInstrumentTBL && (
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      justify="center"
                    // justify="center"
                    // style={{ width: "700px", paddingTop: 10, paddingBottom: 15 }}
                    >
                      <CheckCircleOutline
                        style={{ fontSize: 36, color: "#006600" }}
                      />
                      {/* <div style={{ marginLeft: 50, marginTop: -47 }}>fukd bruv</div> */}
                      <p>LMS Calibration files VALID</p>
                    </Grid>
                  )}

                {!calFilesValid && (
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justify="center"
                  // justify="center"
                  // style={{ width: "700px", paddingTop: 10, paddingBottom: 15 }}
                  >
                    <ErrorOutline style={{ fontSize: 36, color: "#FF0000" }} />
                    <p>LMS Calibration files INVALID</p>
                  </Grid>
                )}
              </Grid>

              {calSelectEnabled &&
                !state.LMSInstrumentRES &&
                !state.LMSInstrumentLCP &&
                !state.LMSInstrumentTBL && (
                  <p
                    style={{
                      // visibility: wheelsUpDownError ? "visible" : "hidden",
                      fontSize: 12,
                      color: "#757575",
                      // marginTop: 0,
                      textAlign: "center",
                    }}
                  >
                    LMS Calibration files must use the file name format:
                    <br />
                    &lt;Laser Serial No.&gt;_&lt;Aircraft&gt;_&lt;LMS
                    Version&gt;_&lt;Calibration Date&gt;, e.g.:
                    <br />
                    &lt;First 4 digits laser serial No.&gt;{SENSOR_NUMBER}_{aircraft}_{"LMS"}_
                    {getCalDate(calibrationDate)}.LCP
                    <br />
                    &lt;First 4 digits laser serial No.&gt;{SENSOR_NUMBER}_{aircraft}_{"LMS"}_
                    {getCalDate(calibrationDate)}.RES
                    <br />
                    &lt;First 4 digits laser serial No.&gt;{SENSOR_NUMBER}_{aircraft}_{"LMS"}_
                    {getCalDate(calibrationDate)}.TBL
                  </p>
                )}
            </Grid>
          )}
        </div>

        {/* TODO on submit trim() appropriate strings */}
        <Button
          variant="contained"
          component="span"
          color="primary"
          disabled={!submitValid}
          // disabled={
          //   this.state.Aircraft === "" ||
          //   this.state.Aircraft === undefined ||
          //   this.state.SensorName === "" ||
          //   this.state.SensorName === undefined ||
          //   this.state.SurveyDate === "" ||
          //   this.state.SurveyDate === undefined
          // }
          onClick={handleSubmit}
          style={{ width: 265, height: 30, marginRight: 10, marginTop: 10 }}
        >
          Create Entry
        </Button>
      </Grid>
    </div>
  );
};

// export default SAFlightCreate;

const mapStateToProps = (state) => ({
  token: state.token,
  submitSuccess: state.saFlightPostSuccess,
  submitLoading: state.saFlightPostLoading,
  saCal: state.saCal,
  // data: state.TMProcessingReducer.data,
  // isLoading: state.TMProcessingReducer.isLoading,
  // error: state.TMProcessingReducer.error,
  // total: state.TMProcessingReducer.total,
  // // sensorEquipment: state.sensorEquipment ? state.sensorEquipment.map(item => { return { "label": item.Name, "value": item.Name } }) : [],
  // projectManagers:
  //   state.uniqueValuesFetchSuccess &&
  //   state.uniqueValuesFetchSuccess["project.ProjectManager"]
  //     ? state.uniqueValuesFetchSuccess["project.ProjectManager"].map((item) => {
  //         return { label: item, value: item };
  //       })
  //     : [],
});

const mapDispatchToProps = (dispatch) => {
  return {
    // setQueryParams: (token, payload) => {
    //   dispatch(saProjectQueryParams(payload));
    //   dispatch(saProjectFetchList(token));
    // },
    submitFlight: (payload) => dispatch(saFlightPost(payload)),
    // setCalQueryParams: (payload) => {
    //   dispatch(saCalQueryParams(payload));
    //   dispatch(saCalFetchList());
    // },
    getCalQueryParams: (payload) => dispatch(saCalFetchList(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SAFlightCreate);
